import pt from "date-fns/locale/pt-BR";
import en from "date-fns/locale/en-GB";
import es from "date-fns/locale/es";

export const getDateFnsLocale = (language: string) => {
  switch (language) {
    case "pt-BR":
      return pt;
    case "es":
      return es;
    case "en":
    default:
      return en;
  }
};

export const getCurrencyByLanguage = (language: string): string => {
  switch (language) {
    case "pt-BR":
      return "BRL";
    case "es":
      return "USD";
    case "en":
    default:
      return "USD";
  }
};
